import type { EarnVaultHolding } from "./useEarnVaultBalance"

export function computeEarnHomeMetrics(params: {
  vaultHoldings: EarnVaultHolding[]
  vaultPositionCount: number
  vaultAprByAssetId: Record<string, number | undefined>
  stakedNear: bigint
  stakedUsd: number | null | undefined
  nearStakingAprPercent: number
}): { positionCount: number; blendedApy: number | null } {
  const nearStakingPositionCount = params.stakedNear > 0n ? 1 : 0
  const positionCount = params.vaultPositionCount + nearStakingPositionCount

  let weightedTotal = 0
  let totalValueUsd = 0

  for (const holding of params.vaultHoldings) {
    const apr = params.vaultAprByAssetId[holding.defuseAssetId]
    if (
      apr == null ||
      !Number.isFinite(apr) ||
      !Number.isFinite(holding.usdValue) ||
      holding.usdValue <= 0
    ) {
      continue
    }
    weightedTotal += holding.usdValue * apr
    totalValueUsd += holding.usdValue
  }

  if (params.stakedUsd != null && params.stakedUsd > 0) {
    weightedTotal += params.stakedUsd * params.nearStakingAprPercent
    totalValueUsd += params.stakedUsd
  }

  return {
    positionCount,
    blendedApy: totalValueUsd > 0 ? weightedTotal / totalValueUsd : null,
  }
}
